import React from 'react';
import styled from 'styled-components';
import {
  BodyThree,
  SubtitleThree
} from '../../../../../styles/theme/default/typography';
import { MenuItemLink } from './MenuList';

const Wrapper = styled.ul`
  padding: 0px 0px 15px 0px;

  li {
    padding: 0 15px;
  }

  list-style: none;
  &:focus {
    outline: none;
  }

  .title-back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    .back-icon,
    .filler,
    .title-menu-list-details {
      flex: 1 1 0px;
    }
    .title-menu-list-details {
      text-align: center;
    }

    .back-icon {
      display: flex;
      img {
        width: 20px;
        height: auto;
      }
    }
  }
`;

function MenuListDetails({ name, data, className, resetSelected }) {
  return (
    <Wrapper className={className}>
      <li className="title-back">
        <div className="back-icon" onClick={resetSelected}>
          <img
            src="https://theinside.imgix.net/icons/back-nav-arrow.svg"
            alt="back"
          />
        </div>
        <BodyThree className="title-menu-list-details" bold>
          {name}
        </BodyThree>
        <div className="filler" />
      </li>

      {data.map((data, i) => {
        return (
          <React.Fragment key={i}>
            <SubHeading>
              <SubtitleThree bold>{data.title}</SubtitleThree>
            </SubHeading>
            {data.links.map((link, i) => {
              return (
                <MenuItemLink
                  key={i}
                  name={link.title}
                  to={link.url}
                  external={link.external}
                />
              );
            })}
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
}

export default MenuListDetails;

const SubHeading = styled.div`
  background: ${({ theme }) => theme.colors.oatmilk};
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 15px;
`;
